import * as z from 'zod'
import type {
  ProducttypeCoverageKeywordRow,
  ProducttypeCoverageSalesRow,
  ProducttypeKeywordCountRow,
  ProducttypeKeywordTrafficRow,
  ProducttypeMasterRow,
  ProducttypeTrafficAggregateRow,
} from '@/api/keywordCoverage/types'

export const producttypeMasterRowSchema: z.ZodType<ProducttypeMasterRow> = z.object({
  producttypeKey: z.string(),
  producttypeName: z.string(),
  description: z.string().nullable(),
  aiInstructions: z.string().nullable(),
  deactivated: z.boolean().nullable(),
  state: z.object({ name: z.string() }).nullable(),
})

export const producttypeCoverageSalesRowSchema: z.ZodType<ProducttypeCoverageSalesRow> = z.object({
  producttypeKey: z.string(),
  sales365: z.number(),
})

export const producttypeCoverageKeywordRowSchema: z.ZodType<ProducttypeCoverageKeywordRow> =
  z.object({
    producttypeKey: z.string(),
    keyword: z.object({
      keywordType: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]),
      isAlias: z.boolean(),
    }),
  })

export const producttypeKeywordCountRowSchema: z.ZodType<ProducttypeKeywordCountRow> = z.object({
  producttypeKey: z.string(),
  keywordCount: z.number().int(),
})

export const producttypeKeywordTrafficRowSchema: z.ZodType<ProducttypeKeywordTrafficRow> = z.object(
  {
    producttypeKey: z.string(),
    keyword: z.object({
      keywordType: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]),
      isAlias: z.boolean(),
      traffic: z.number().nullable(),
    }),
  },
)

export const producttypeTrafficAggregateRowSchema: z.ZodType<ProducttypeTrafficAggregateRow> =
  z.object({
    producttypeKey: z.string(),
    traffic: z
      .number()
      .nullable()
      .transform((value) => value ?? 0),
  })
